export default __webpack_public_path__ + "static/media/youractiongroupbutton@2x.0a823577.png";